import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import './disconnect.styles.scss'
import Service from './disconnect.service'
import Loading from '../../../../../../components/loading/loading.component'

class Disconnect extends React.Component {

    constructor(props) {
        super(props)
        this.service = Service(this)
        this.state = this.service.getDefaultState()
    }

    componentDidMount() {
        this.service.disconnect()
    }

    render() {
        return (
            <div className="disconnect card">
                <div className="header">
                    <h4>Clearing Cache {this.props.customer.userId}</h4>
                </div>
                <Loading/>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
}

export default connect(mapStateToProps)(withRouter(Disconnect))